import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WhatsAppIcon } from "@/components/icons/WhatsAppIcon";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

interface PossibilitiesProps {
  customButton?: {
    text: string;
    onClick: (e: React.MouseEvent) => void;
  };
}

const Possibilities = ({ customButton }: PossibilitiesProps = {}) => {
  const location = useLocation();
  const isProfessoresPage =
    location.pathname === "/areas-de-atuacao/professores-quinquenios";
  const isAposentadosPage =
    location.pathname === "/areas-de-atuacao/aposentados-e-pensionistas";
  const isImpostoDeRendaPage =
    location.pathname === "/areas-de-atuacao/imposto-de-renda";

  const handleContactClick = (e: React.MouseEvent) => {
    if (customButton) {
      customButton.onClick(e);
      return;
    }

    e.preventDefault();
    if (isProfessoresPage) {
      window.dispatchEvent(new CustomEvent("open-professores-popup"));
    } else if (isAposentadosPage) {
      window.dispatchEvent(new CustomEvent("open-aposentados-popup"));
    } else if (isImpostoDeRendaPage) {
      window.dispatchEvent(new CustomEvent("open-imposto-popup"));
    } else {
      window.dispatchEvent(new CustomEvent("open-home-popup"));
    }
  };

  const items = [
    "Receba o pagamento de todos os valores atrasados dos últimos 5 anos.",
    "Garanta um aumento permanente do salário.",
    "Dê entrada de forma online, sem necessidade de comparecer pessoalmente a nenhum fórum.",
    "Tenha garantia de recebimento do valor da condenação.",
    "Sem necessidade de pagar custas iniciais para dar entrada no processo.",
    "Honorários advocatícios serão devidos apenas se houver sucesso na ação. RISCO ZERO.",
  ];

  return (
    <section className="py-24 text-white overflow-hidden relative">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url("https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a33199d6ff9a379cdd9100a.webp")',
        }}
      />
      <div className="absolute inset-0 z-0 bg-primary/50" />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-primary via-primary/20 to-primary" />

      <div className="container mx-auto px-2 sm:px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-5xl mx-auto text-center space-y-12"
        >
          <h2 className="text-[30px] md:text-[48px] lg:text-[48px] font-bold font-serif leading-tight -mx-2 sm:mx-0">
            As possibilidades das nossas Ações Judiciais:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
            {items.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-start gap-4 group"
              >
                <div className="shrink-0 mt-1">
                  <CheckCircle2 className="w-7 h-7 text-accent drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]" />
                </div>
                <p className="text-base md:text-xl font-medium leading-relaxed group-hover:text-accent transition-colors">
                  {item}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: 0.8 }}
            className="pt-8"
          >
            <a
              href="#contato"
              onClick={handleContactClick}
              className="inline-flex items-center justify-center gap-2 sm:gap-3 whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 w-[85%] sm:w-auto font-bold px-6 py-4 sm:px-8 sm:py-[18px] h-auto rounded-full bg-[#075E54] hover:bg-[#043b35] text-white border-2 border-white shadow-lg hover:scale-105 transition-transform uppercase text-sm sm:text-base mx-auto sm:mx-0"
            >
              <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
              {customButton
                ? customButton.text
                : isProfessoresPage
                  ? "Fazer análise gratuita do holerite"
                  : isAposentadosPage
                    ? "Fazer análise gratuita do holerite"
                    : isImpostoDeRendaPage
                      ? "Fazer Checklist do Imposto de Renda"
                      : "Entrar em contato"}
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Possibilities;
